<h4>Alberta - {{subject}}</h4>
<ng-container *ngIf="program">
    <div class="old-grade" [innerHTML]="program.course"></div>
</ng-container>